// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__XllbE","infoBtn":"quickbooks_infoBtn__36J-p","formBox":"quickbooks_formBox__1PXr_","formFooter":"quickbooks_formFooter__Sjum-"};